import * as React from "react";
const SvgHexagon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 72, height: 82, viewBox: "0 0 72 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M36 0L72 22.5V60L36 82L0 60V24L36 0Z", fill: "#2C3F57" }));
export default SvgHexagon;
